import { useContextSelector } from 'use-context-selector'

import { TurnListContext } from '../context/TurnListProvider'

export const useOccurrencesTrees = () => {
  const occurrenceTrees = useContextSelector(
    TurnListContext,
    (turnList) => turnList.occurrenceTrees
  )

  return {
    occurrenceTrees,
  }
}
